import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/component/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: 's', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'G', value: 'is_group', sortable: true, filterable: true, divider: true, type: 'bool', width: 30},
        {text: 'DGS', value: 'dgs', sortable: true, filterable: true, divider: true, type: 'bool', width: 40},
        {text: 'AOI', value: 'aoi', sortable: true, filterable: true, divider: true, type: 'bool', width: 40},
        {text: 'Article', value: 'article', sortable: true, filterable: true, divider: true, width: 90},
        {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true,},
        {text: 'MPN', value: 'mpn', sortable: true, filterable: true, divider: true,},
        {text: 'Type', value: 'article_type', sortable: true, filterable: true, divider: true, width: 80},
        {text: 'Case/Package', value: 'case_package', sortable: true, filterable: true, divider: true, width: 80},
        {text: 'Category', value: 'category', sortable: true, filterable: true, divider: true, width: 110},
        {text: 'Subcategory', value: 'subcategory', sortable: true, filterable: true, divider: true, width: 110},
        // {text: 'Case/Packages', value: 'case_package', sortable: true, filterable: true, divider: true, width: 140},
        // {text: 'Datasheet', value: 'datasheet', datasheet: false, filterable: true, divider: true,},
        {text: 'Image', value: 'image', sortable: false, filterable: true, divider: true, width: 64},

        // {text: 'Category path', value: 'category_path', sortable: false, filterable: true, divider: true,},
        // {text: 'Category name', value: 'category_name', sortable: false, filterable: true, divider: true,},
        {text: 'Description', value: 'description', sortable: false, filterable: true, divider: true,},
        // {text: 'Information', value: 'information', datasheet: false, filterable: true, divider: true,},
        // {text: 'Source url', value: 'source_url', datasheet: false, filterable: true, divider: true,},
        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        // {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['alias'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filterGroupSingle: [],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        ComponentTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}